import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin, Alert } from 'antd';
import api from '../services/api';

const AuthToken = ({ onLogin }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const authenticateWithToken = async () => {
      try {
        const token = searchParams.get('t');

        if (!token) {
          setError('Token não fornecido na URL');
          setLoading(false);
          return;
        }

        const response = await api.post('/auth-token', { token });

        // Salvar token e dados do usuário
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));

        // Fazer login
        onLogin(response.data.user);

        // Redirecionar para página principal do organizador
        navigate('/team-config');

      } catch (error) {
        console.error('Erro na autenticação por token:', error);
        setError(error.response?.data?.message || 'Erro na autenticação');
        setLoading(false);
      }
    };

    authenticateWithToken();
  }, [searchParams, onLogin, navigate]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: 16
      }}>
        <Spin size="large" />
        <p>Autenticando...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        padding: 20
      }}>
        <Alert
          message="Erro de Autenticação"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  return null;
};

export default AuthToken;